<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4t0Oqq/tc-custom/9781454927839.jpg?1736478804119" alt="This image is the cover for the book Quotes for Nasty Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quotes for Nasty Women
      </h1>
      <p class="bookDescription body article font2">
        <b>A compendium of inspiring, witty, and nasty quotations by and about powerful women through history.</b><br/><br/> When Donald Trump referred to Hillary Clinton as “such a nasty woman” during a presidential debate in 2016, women everywhere—whatever their politics or feelings about Clinton—felt a jolt of recognition. In response, they promptly turned his insult into an empowering slogan. This book celebrates women’s power and resilience with quotes that demonstrate what it means to be <i>nasty</i>.<br/><br/> The book includes entries from women of the ancient world like Cleopatra; freedom fighters like Harriet Tubman; founding mothers like Mary Wollstonecraft and Elizabeth Cady Stanton; and feminist icons such as Gloria Steinem and Betty Friedan. It also features the words of politicians and government leaders; groundbreakers in arts and culture; celebrities; and the mothers, daughters, and sisters at home. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Picone
      </h2>
      
      <p class="authorDescription body article">Linda Picone is a writer and editor. Her books include Carpe Diem: Quotes to Seize the Day (Fall River Press) and The Daily Book of Positive Quotations (Fairview Press).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?423c3edf